import { Link } from "@/components/link";
import { Alert, AlertTitle, AlertDescription } from "@/components/ui/alert";
import { PATH_SIGN_IN } from "@/constants";
import { CircleChevronLeft } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function UnauthorizedSuccess() {
  const { t } = useTranslation();

  return (
    <div className="grid gap-4">
      <Alert variant="success">
        <AlertTitle>{t("resetPassword.passwordChangedTitle")}</AlertTitle>
        <AlertDescription>
          {t("resetPassword.passwordChangedDescription")}
        </AlertDescription>
      </Alert>
      <footer>
        <Link to={PATH_SIGN_IN} icon={CircleChevronLeft} className="pl-0">
          {t("resetPassword.backButton")}
        </Link>
      </footer>
    </div>
  );
}
